module.exports = __webpack_public_path__ + "img/logo.2ce70a2c.png";